import { render, staticRenderFns } from "./BoxesBadgeList.vue?vue&type=template&id=b8545dd0&scoped=true&"
import script from "./BoxesBadgeList.vue?vue&type=script&lang=js&"
export * from "./BoxesBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./BoxesBadgeList.vue?vue&type=style&index=0&id=b8545dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8545dd0",
  null
  
)

export default component.exports